import { getUserProfile } from 'app/selectors';
import { useAccess } from 'hooks/useAccess';

import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { CatalogVariablesOtherTab } from '../types';

const NTC_ADMINISTRATOR_ROLE = 'NTCAdministrator';

export const useCatalogVariablesOtherAccess = (tab: CatalogVariablesOtherTab) => {
    const { catalogs: catalogsRules } = useAccess();
    const profileInfo = useSelector(getUserProfile) as { roles?: string[] } | undefined;

    const isNtcAdministrator = Boolean(profileInfo?.roles?.includes(NTC_ADMINISTRATOR_ROLE));
    const isGlobalTab = tab === CatalogVariablesOtherTab.Global;

    const canMutateVariables = isGlobalTab ? isNtcAdministrator : Boolean(catalogsRules?.canEdit);
    const canDeleteVariables = isGlobalTab ? isNtcAdministrator : Boolean(catalogsRules?.canDelete);

    return useMemo(
        () => ({
            isNtcAdministrator,
            canCreateVariable: canMutateVariables,
            canEditDirectory: Boolean(catalogsRules?.canEdit),
            variablesRules: {
                ...catalogsRules,
                canEdit: canMutateVariables,
                canDelete: canDeleteVariables,
            },
        }),
        [canDeleteVariables, canMutateVariables, catalogsRules, isNtcAdministrator],
    );
};
